import {RouterContextProvider, createContext} from 'react-router';

import store from './store';

export const routerContext = createContext<typeof store>();

export const getState = (context: RouterContextProvider) => context.get(routerContext).getState();
export const getDispatch = (context: RouterContextProvider) =>
  context.get(routerContext).dispatch as TDispatch;
